import LogRocket from 'logrocket';
import * as Sentry from '@sentry/react';

import { Config } from 'config';

const { sentry, logRocketApp } = Config;
const { dsn, release, environment } = sentry;

export const setupMonitoring = () => {
  const shouldInitSentry = Boolean(dsn && release);
  const shouldInitLogRocket = Boolean(logRocketApp && release);

  if (shouldInitSentry) {
    try {
      Sentry.init({
        dsn,
        release,
        environment,
        enableLogs: true,
        sendDefaultPii: true,
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
          }),
        ],
        ignoreErrors: [
          /An error has occurred and we could not establish a connection to your Clover device/i,
          /Previous payment attempt failed\. Please retry again/i,
          /Wrong approval password, try another one/i,
          /Request already in progress using method RESET_DEVICE_RESPONSE/i,
          /User is not a team member for this event/i,
        ],
      });
    } catch (error) {
      console.error(`[Setup Sentry]: ${error}`);
    }
  }

  if (shouldInitLogRocket) {
    try {
      LogRocket.init(logRocketApp, {
        release,
        console: {
          shouldAggregateConsoleErrors: true,
        },
      });

      LogRocket.getSessionURL((sessionURL) => {
        if (sessionURL) {
          Sentry.setContext('LogRocket', {
            sessionURL: sessionURL,
            timestamp: new Date().toISOString(),
          });

          Sentry.setTag('logRocketSession', 'active');
        }
      });
    } catch (error) {
      console.error(`[Setup LogRocket]: ${error}`);
    }
  }
};
